import { render, staticRenderFns } from "./CopyContent.vue?vue&type=template&id=20680f8d&scoped=true"
import script from "./CopyContent.vue?vue&type=script&lang=js"
export * from "./CopyContent.vue?vue&type=script&lang=js"
import style0 from "./CopyContent.vue?vue&type=style&index=0&id=20680f8d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20680f8d",
  null
  
)

export default component.exports